const path = require('path');
const { settings } = require('@buzzfeed/rig');

const relaxedSetting = (key) => {
  try {
    return settings.get(key);
  } catch (e) {
    return false;
  }
};

const relaxedOnBoot = (key) => {
  if (relaxedSetting('CLUSTER')) {
    // runtime - enforce key presence
    return settings.get(key);
  }
  // on build - do not enforce key presence
  return relaxedSetting(key);
};

let constants = {};

// The following constants are relied upon during CI build, and so have defaults inserted here
// which mirrors config.yml - I'm sorry about this, rig doesn't expose those variables during build
// which creates this duplication of effort

// More are required in production "run" mode, of course, but the following change what is actually built
// which cannot be reconfigured at runtime.

// NODE_ENV (this establishes isProd, which changes minification settings)
// ASSETS_URL must be set, but does read at runtime

constants = {
  NODE_ENV: relaxedOnBoot('NODE_ENV') || 'production',
  MAPI_ENV: relaxedOnBoot('MAPI_ENV') || 'production',
  ASSETS_URL: relaxedOnBoot('ASSETS_URL') || '/static-assets/cambria/app/',
  IS_TESTING: relaxedSetting('IS_TESTING'),
  CAMBRIA_ENV: relaxedOnBoot('CAMBRIA_ENV'),
  WEBPACK_TARGETS: relaxedOnBoot('WEBPACK_TARGETS'),
  BUNDLE_ANALYZER: relaxedOnBoot('BUNDLE_ANALYZER'),
  REDIS_HOST: relaxedOnBoot('REDIS_HOST'),
  REDIS_DB: relaxedOnBoot('REDIS_DB'),
  REDIS_PROTOCOL: relaxedOnBoot('REDIS_PROTOCOL'),
  REDIS_READ_HOST: relaxedOnBoot('REDIS_READ_HOST'),
  API_GATEWAY_HOST: relaxedOnBoot('API_GATEWAY_HOST'),
  API_GATEWAY_TOKEN: relaxedOnBoot('API_GATEWAY_TOKEN'),
  SPOT_ENGAGEMENT_TOKEN: relaxedOnBoot('SPOT_ENGAGEMENT_TOKEN'),
  STAGE_BASIC_AUTH_USER: relaxedOnBoot('STAGE_BASIC_AUTH_USER'),
  STAGE_BASIC_AUTH_PASS: relaxedOnBoot('STAGE_BASIC_AUTH_PASS'),
  SIA_KEY_PATH: relaxedOnBoot('SIA_KEY_PATH'),
  SIA_CERT_PATH: relaxedOnBoot('SIA_CERT_PATH'),
  SIA_CERT_BUNDLE_PATH: relaxedOnBoot('SIA_CERT_BUNDLE_PATH'),
  CHECK_OUT_URL: relaxedOnBoot('CHECK_OUT_URL'),
  GIT_COMMIT: false, // Needs fixing for BF - we don't have access to this (though it would be very nice)
  STATSD_HOST: relaxedOnBoot('STATSD_HOST'),
  CAMBRIA_S3_ASSET_BUCKET: false, // This one was from Fleks; needs looking in to
  JWT_SECRET_KEY: relaxedOnBoot('JWT_SECRET_KEY'),
  CARD_PREVIEW_SECRET: relaxedOnBoot('CARD_PREVIEW_SECRET'),
  CAPI_ENV: relaxedOnBoot('CAPI_ENV'),
  DIST_DIR: '/dist',
  ROOT_DIR: path.resolve(__dirname, '..'),
  NO_OPINARY_TRAIT_SLUG: 'noOpinary',
  SIGN_IN_URL: relaxedOnBoot('AUTH0_SIGN_IN_URL'),
  SIGN_UP_URL: relaxedOnBoot('AUTH0_SIGN_UP_URL'),
  LOG_OUT_URL: relaxedOnBoot('AUTH0_LOG_OUT_URL'),
  AUTHORIZATION_URL: relaxedOnBoot('MAPI_AUTHORIZATION_URL'),
  CHANGE_PASSWORD_URL: relaxedOnBoot('AUTH0_CHANGE_PASSWORD_URL'),
  LISTENING_PORT: relaxedOnBoot('PORT'),
  CAPI_CONSUMER: relaxedOnBoot('CAPI_CONSUMER') || 'cambria',
  DATADOG_NAMESPACE: 'huffpost_cambria',
  FLIP_PAY_AUTH: relaxedOnBoot('FLIP_PAY_AUTH'),
  S3_ACCESS_KEY_ID: relaxedOnBoot('S3_ACCESS_KEY_ID'),
  S3_SECRET_ACCESS_KEY: relaxedOnBoot('S3_SECRET_ACCESS_KEY'),
  RECAPTCHA: relaxedOnBoot('RECAPTCHA'),
};

module.exports = constants;
